import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAppStore = create(
  persist(
    (set) => ({
      name: "",
      setName: (name) => set({ name: name }),
    }),
    {
      name: "wce-attr",
    }
  )
);

export default useAppStore;
